import { toast } from 'sonner';
import { useAddCandidateToPosition } from './useAddCandidateToPosition';

export function useLinkActions(
  positionId: string,
  onClose: () => void
): {
  linkExisting: (candidateId: string) => void;
  createAndLink: (name: string, email: string, country?: string) => void;
  isLoading: boolean;
} {
  const { addCandidate, isLoading } = useAddCandidateToPosition();

  const callbacks = {
    onSuccess: (): void => {
      toast.success('Candidate linked successfully');
      onClose();
    },
    onError: (error: Error): void => {
      toast.error(
        error.message?.includes('already linked') ? 'Candidate already linked' : 'Failed to link'
      );
    },
  };

  const linkExisting = (candidateId: string): void => {
    addCandidate({ positionId, data: { candidateId } }, callbacks);
  };

  const createAndLink = (name: string, email: string, country?: string): void => {
    addCandidate({ positionId, data: { name, email, country } }, callbacks);
  };

  return { linkExisting, createAndLink, isLoading };
}
